export enum CONTEXTS {
	ERROR   = 'error',
	WARNING = 'warning',
	SUCCESS = 'success',
	INFO    = 'info',
}

export const CONTEXT_COLORS = {
	[ CONTEXTS.INFO ]:    'teal',
	[ CONTEXTS.SUCCESS ]: 'green',
	[ CONTEXTS.WARNING ]: 'orange',
	[ CONTEXTS.ERROR ]:   'red',
};
